<div id="fsModal" class="modal-popup">
  <!-- Modal Content -->
  <div id="fsModalContent" class="modal-popup-content"></div>
  <div id="fsModalMiniPopUp" class="modal-mini-popup">
    <!-- Modal Content -->
    <div id="fsModalMiniContentPopup" class="modal-mini-popup-content"></div>
  </div>
</div>

<div id="fsModalMessage" class="modal-mini-popup">
  <!-- Modal Content -->
  <div id="fsModalMessageContent" class="modal-mini-popup-content"></div>
</div>
